export const WHATSAPP_URL = "https://wa.me/573332782819";
export const WHATSAPP_MESSAGE_URL = "https://wa.me/573332782819?text=Hola,%20quiero%20conocer%20PastoreApp%20y%20saber%20c%C3%B3mo%20puede%20ayudar%20a%20mi%20iglesia.";
